import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministrationRoutingModule } from './administration-routing.module';
import { AdministrationComponent } from './administration.component';
import { FunctionMasterComponent } from './function-master/function-master.component';
import { ComponentMasterComponent } from './component-master/component-master.component';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../common/shared.module';
import { AssessRequestsModule } from '../assess-requests/assess-requests.module';
import { RegulatoryGroupMasterComponent } from './regulatory-group-master/regulatory-group-master.component';
import { ViewGroupComponent } from './regulatory-group-master/view-group/view-group.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { PropertyMasterComponent } from './property-master/property-master.component';
import { LeadContactsManagementComponent } from './lead-contacts-management/lead-contacts-management.component';
import { SelfAssessmentComponent } from './self-assessment/self-assessment.component';

@NgModule({
  declarations: [
    AdministrationComponent,
    FunctionMasterComponent,
    ComponentMasterComponent,
    RegulatoryGroupMasterComponent,
    ViewGroupComponent,
    PropertyMasterComponent,
    LeadContactsManagementComponent,
    SelfAssessmentComponent,

  ],
  imports: [
    CommonModule,
    AdministrationRoutingModule,
    HttpClientModule,
    SharedModule,
    AssessRequestsModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class AdministrationModule { }
